import { render, staticRenderFns } from "./page-index.vue?vue&type=template&id=13acaea0&scoped=true"
import script from "./page-index.vue?vue&type=script&lang=js"
export * from "./page-index.vue?vue&type=script&lang=js"
import style0 from "@/styles/roatestyle.css?vue&type=style&index=0&id=13acaea0&prod&scoped=true&lang=css&external"
import style1 from "./page-index.vue?vue&type=style&index=1&id=13acaea0&prod&lang=scss&scoped=true"
import style2 from "./page-index.vue?vue&type=style&index=2&id=13acaea0&prod&lang=scss"
import style3 from "./page-index.vue?vue&type=style&index=3&id=13acaea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13acaea0",
  null
  
)

export default component.exports